<template>
  <el-table-column
    prop="web"
    sortable
    label="Honlap"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      {{ scope.row.web }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'web',
  };
</script>
